<template>
  <v-container fill-height fluid>
    <v-layout align-center justify-center>
      <grid-loader :loading="true" color="light-blue" class="spinner"/>
    </v-layout>
  </v-container>
</template>

<script>
import GridLoader from 'vue-spinner/src/GridLoader'

export default {
  name: 'loading-view',
  components: {
    GridLoader
  }
}
</script>

<style scoped>
.spinner {
  margin-top: -128px;
}
</style>
